var installedModules = {};
__webpack_require__.consumesLoadingData.moduleIdToConsumeDataMapping = {
	21345: {
		fallback: () => (__webpack_require__.e(957).then(() => (() => (__webpack_require__(52957))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "3.5.25",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "vue",
	},
	33755: {
		fallback: () => (__webpack_require__.e(667).then(() => (() => (__webpack_require__(13667))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: "^1.7.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@shipbob/auth",
	},
	53503: {
		fallback: () => (Promise.all([__webpack_require__.e(965), __webpack_require__.e(458)]).then(() => (() => (__webpack_require__(74965))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: "^4.6.4",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "vue-router",
	},
	68834: {
		fallback: () => (__webpack_require__.e(278).then(() => (() => (__webpack_require__(93278))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: "^1.17.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "axios",
	},
	70306: {
		fallback: () => (Promise.all([__webpack_require__.e(124), __webpack_require__.e(325)]).then(() => (() => (__webpack_require__(82124))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: "4.1.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "vuex",
	},
	73834: {
		fallback: () => (__webpack_require__.e(21).then(() => (() => (__webpack_require__(31021))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: "^3.5.2",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "vue-axios",
	},
	34458: {
		fallback: () => (__webpack_require__.e(957).then(() => (() => (__webpack_require__(52957))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^3.5.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "vue",
	},
	13325: {
		fallback: () => (__webpack_require__.e(957).then(() => (() => (__webpack_require__(52957))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^3.2.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "vue",
	},
	21992: {
		fallback: () => (__webpack_require__.e(36).then(() => (() => (__webpack_require__(21036))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: "^1.6.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@shipbob/telemetry",
	}
};
var moduleToHandlerMapping = {};
// no consumes in initial chunks
__webpack_require__.consumesLoadingData.chunkMapping = {
	"325": [
		13325
	],
	"458": [
		34458
	],
	"550": [
		21345,
		33755,
		53503,
		68834,
		70306,
		73834
	],
	"992": [
		21992
	]
};
__webpack_require__.f.consumes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.consumes({
	chunkMapping: __webpack_require__.consumesLoadingData.chunkMapping,
	installedModules: installedModules,
	chunkId: chunkId,
	moduleToHandlerMapping,
	promises: promises,
	webpackRequire:__webpack_require__
	});
}